import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { actions as modalActions } from '../../reducers/modal.reducer';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import ContactPersonAdd from './ContactPersonAdd.modal';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import Table from '../common/table/Table.react';
var ContactPersons = function ContactPersons() {
  var navigate = useNavigate();
  var _useParams = useParams(),
    app = _useParams.app;
  var dispatch = useDispatch();
  var contacts = useSelector(function (s) {
    return s.ppc.contacts;
  });
  useEffect(function () {
    dispatch({
      type: ppcActions.contactPersons,
      payload: {}
    });
  }, []);
  var columns = {
    id: {
      title: '_id',
      visible: false
    },
    name: {
      title: 'Name',
      onClick: function onClick(_ref) {
        var row = _ref.row;
        return navigate("/".concat(app, "/contact-person/").concat(row._id));
      }
    },
    slot: {
      title: 'Slot',
      visible: true,
      size: 'contain'
    }
  };
  var data = Object.values(contacts).filter(function (x) {
    return !x.archived && x.clientApp === app;
  }).map(function (x) {
    return {
      _id: x._id,
      name: x.name,
      slot: x.slot
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Contact Persons",
    button: {
      label: 'Add',
      type: 'add',
      permission: "edit-".concat(app, "-contacts"),
      onClick: function onClick() {
        dispatch({
          type: modalActions.add,
          payload: {
            component: /*#__PURE__*/React.createElement(ContactPersonAdd, {
              app: app
            })
          }
        });
      }
    }
  }), /*#__PURE__*/React.createElement(Table, {
    columns: columns,
    data: data,
    sort: {
      by: 'slot'
    }
  }))));
};
export default ContactPersons;